import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';

//import { AuthProvider } from "../providers/auth/auth";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  //constructor(public authProvider: AuthProvider) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //const token = this.authProvider.getToken();
    let token = localStorage.getItem('token');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req);
  }

}



// WEBPACK FOOTER //
// ./src/interceptors/auth.interceptor.ts